import { render, staticRenderFns } from "./RpmClassification.vue?vue&type=template&id=2b37e515"
import script from "./RpmClassification.vue?vue&type=script&lang=js"
export * from "./RpmClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports